import basePageFields from '@fragments/pages/basePageFields';

export default gql`
    fragment StaffFragment on Staff {
        ${basePageFields}
    }
`;
